import { combineReducers } from 'redux';
import customerReducer from 'redux/analytics/customerSlice';
import analytics from 'redux/analytics/orderSlice';
import trailerReducere from 'redux/asssets/trailersSlice';
import searchReducer from 'redux/briefing/archiveSearchSlice';
import briefingReducer from 'redux/briefing/briefingSlice';
import shiftReducer from 'redux/briefing/shiftSlice';
import activeBusessSlice from 'redux/logistics/activeBusesSlice';
import BusSlice from 'redux/logistics/busesSlice';
import specificOrder from 'redux/logistics/orders/specificOrder';
import ordersSlice from 'redux/logistics/orders/ordersSlice';
import specificBus from 'redux/logistics/specificBus';
import tripsReducer from 'redux/logistics/trips/tripsSlice';
import updatesReducer from 'redux/logistics/updates/updatesSlice';
import modalState from 'redux/navigation/modalStates';
import navigationSlice from 'redux/navigation/proprioceptor';
import permissionsSlice from 'redux/permissions/permissionsSlice';
import KPIs from 'redux/KPIs/KPIsSlice';
import scraperOpsSlice from 'redux/scraperOperations/operationsSlice';
import laneSLice from 'redux/warehouse/lanesSlice';
import TerminalSlice from 'redux/warehouse/terminalSlice';
import warehouseReducer from 'redux/warehouse/warehouseSlice';
import alerts from 'redux/briefing/alerts';

const rootReducer = combineReducers({
  // logistics
  warehouse: warehouseReducer,
  shift: shiftReducer,
  briefing: briefingReducer,
  alerts,
  archiveSearch: searchReducer,
  terminals: TerminalSlice,
  buses: BusSlice,
  activeBuses: activeBusessSlice,
  lanes: laneSLice,
  orders: ordersSlice,
  customers: customerReducer,
  trailers: trailerReducere,
  specificBus,
  specificOrder,
  trips: tripsReducer,
  updates: updatesReducer,

  // reporting
  KPIs,
  analytics,

  // Navigation
  scraperOperations: scraperOpsSlice,
  permissions: permissionsSlice,
  navigation: navigationSlice,
  modal: modalState,
});

export default rootReducer;
